<template>
  <v-container fluid>
    <v-layout>
      <v-flex>
        <v-card :style="cardStyle" flat tile md4 lg4 xl4 :to="toLink">
          <v-responsive>
            <v-img contain
              :src="require('@/assets/photos/gallery/' + photoJson.src)"
              height="photoJson.height"
              max-height="400"
            ></v-img>
            <v-card-text class="text-xs-center">
              <div v-html="photoJson.title"></div>
              <v-btn v-show="toLink" outline color="accent" :to="toLink">VIEW</v-btn>
            </v-card-text>
          </v-responsive>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
export default {
  name: 'photo-card',
  props: {
    photoJson: {
      required: true,
      type: Object,
    },
    toLink: {
      required: false,
      type: String,
    },
    cardStyle: {
      require: false,
      type: String,
    },
  },
};
</script>
